import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { BreadcrumbsComponent } from '@sdvor/seo/ui';
import { SdvorNavigationArrowComponent } from '@sdvor/shared/ui';
import { DeviceService } from '@shared/services';
import { OrderDetailsComponentService } from './order-details.component-service';
import { OrderDetailsModule } from './order-details.module';

@Component({
  selector: 'sd-order-details-page',
  templateUrl: './order-details-page.component.html',
  styleUrls: ['./order-details-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [OrderDetailsComponentService],
  imports: [OrderDetailsModule, BreadcrumbsComponent, SdvorNavigationArrowComponent, RouterLink],
})
export class OrderDetailsPageComponent {
  isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$);
  isTabletDown = toSignal(this.deviceService.isTabletMdDown$);

  constructor(private deviceService: DeviceService) {}
}
